/*
 * @Author: Q in
 * @Date: 2025-11-13 11:45:08
 * @LastEditors: Q in 
 * @LastEditTime: 2026-05-20 15:35:27
 * @FilePath: /bf_web/src/router/index.js
 * @Description: 路由配置文件
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from '@/store/index';
import { isMobile } from '@/utils/validate.js';
Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'PublishList',
		meta: {
			title: '账号列表'
		},
		component: () => import('@/views/PublishList/index.vue')
	},
	{
		path: '/publish.html',
		name: 'Publish',
		meta: {
			title: '上架账号'
		},
		component: () => import('@/views/Publish/index.vue')
	}
];

const router = new VueRouter({
	mode: 'history', // 启用 History 模式
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 每次路由跳转时，滚动到页面顶部
		return { x: 0, y: 0 };
	}
});

router.beforeEach((to, from, next) => {
	if (to.meta && to.meta.title) {
		document.title = '北风商行 -' + to.meta.title; // 设置动态标题
	}

	if (isMobile()) {
		const mobileBase = 'https://m.bfsanjiaozhou.com';

		// 稳健获取路径：优先 pathname，空则从 href 提取
		let realPath = window.location.pathname;
		if (!realPath || realPath === '/') {
			const match = window.location.href.match(/^https?:\/\/[^/]+(\/[^?#]*)/);
			realPath = match ? match[1] : '/';
		}

		const isPublishPage = /^\/publish(\.html)?$/i.test(realPath);
		const targetUrl = isPublishPage ? `${mobileBase}/pages/publish/publish` : mobileBase;

		if (window.location.href !== targetUrl) {
			setTimeout(() => {
				window.location.replace(targetUrl);
			}, 10);
		}
		return;
	}

	next();
});

export default router;
